import { useState, useEffect } from 'react';
import { getCurrencySymbol, CURRENCY_EVENT } from 'src/utils/currency';

export function useCurrencySymbol(): string {
  const [symbol, setSymbol] = useState(getCurrencySymbol);

  useEffect(() => {
    const handler = () => setSymbol(getCurrencySymbol());
    window.addEventListener(CURRENCY_EVENT, handler);
    return () => window.removeEventListener(CURRENCY_EVENT, handler);
  }, []);

  return symbol;
}
